export function objectToURLSearchParams(obj: Record<string, any>): URLSearchParams {
	const params = new URLSearchParams();

	const appendParams = (key: string, value: any) => {
		if (Array.isArray(value)) {
			// Handle array by appending '[]' to the key and adding each value
			value.forEach(item => params.append(`${key}[]`, item));
		} else if (typeof value === 'object' && value !== null) {
			// Handle nested objects recursively
			Object.keys(value).forEach(subKey => {
				appendParams(`${key}[${subKey}]`, value[subKey]);
			});
		} else {
			// Handle primitive values
			params.append(key, value);
		}
	};

	Object.keys(obj).forEach(key => appendParams(key, obj[key]));

	return params;
}

export function objectFromURLSearchParams(url: string): Record<string, any> | undefined {
	const params = new URL(url).searchParams;

	//If no params return null;
	if (params.toString() === '') return undefined;
	const obj: Record<string, any> = {};

	params.forEach((value, key) => {
		const keyParts = key.split('[');
		let currentObj = obj;

		for (let i = 0; i < keyParts.length; i++) {
			const part = keyParts[i].replace(']', '');

			if (i === keyParts.length - 1) {
				currentObj[part] = value;
			} else {
				if (!currentObj[part]) {
					currentObj[part] = {};
				}

				currentObj = currentObj[part];
			}
		}
	});

	return obj;
}
